import React from "react";

export const AnswerLoading = () => {
    return (
        <div className={"flex flex-col gap-4 rounded-lg bg-white p-4 shadow outline-1"}>
            <div className={"flex grow after:animate-dots"}>
                <p>Generating answer</p>
            </div>
        </div>
    );
};
